export default {
  type: "string",
  description: "Response type - constant",
  example: "authorization_code"
};
